import React, { useEffect, useState } from 'react';
import {
	Container,
	Grid,
	Header,
	Image,
	Form,
	Dropdown,
	Table,
	Button,
	Accordion,
	Modal,
	Confirm,
} from 'semantic-ui-react';
import EventService from '../services/EventService';
import { useTitle, useMount } from 'react-use';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import MainMenu from './Menu';
import Logo from '../assests/logo.png';
import { fetchData } from '../store/actions/Archive';
import { firestore } from '../firebase';
import ExportButton from './ExportButton';
import EventEditor from './EventEditor';
import { format } from 'date-fns'
import { duplicateState } from '../utils/Functions';



let options = {
	timeZone: 'Etc/UTC',
	year: 'numeric',
	month: 'numeric',
	day: 'numeric',
	//    hour: 'numeric',
	//    minute: 'numeric',
	//    second: 'numeric',
};


let formatter = new Intl.DateTimeFormat("en-US", options);

function formatDate(value) {
	if (value === null || value === undefined || value === '') return '';
	const date = new Date(value);
	return Number.isNaN(date.getTime()) ? '' : formatter.format(date);
}


function Archive() {
	const dispatch = useDispatch();
	const [open, setOpen] = useState(false);
	const [event, setEvent] = useState(null);
	const [confirm, setConfirm] = useState(null);
	const [removing, setRemoving] = useState(false);
	const [array, setArray] = useState([]);
	const auth = useSelector((state) => state.auth);
	const events = useSelector((state) => state.archive.data);
	const [data, setData] = useState(null);
	const [loading, setLoading] = useState(true);
	const emptyFilter = {
		id: '',
		entity: '',
		typeOfEntity: '',
		gender: '',
		age: '',
		passed: '',
		date: '',
		time: '',
		municipality: '',
		createddate: '',
		duplicateState: ''
	};
	const [filter, setFilter] = useState(emptyFilter);
	const [appliedFilter, setAppliedFilter] = useState(emptyFilter);
	const [order, setOrder] = useState({
		type: 'desc',
		column: 'fecha_evento',
	});

	useTitle('Proyecto CARA | Archivo');
	useMount(() => dispatch(fetchData(auth)));

	useEffect(() => {
		setLoading(true);

		const conditions = Object.create(null);

		if (appliedFilter.entity) {
			conditions.entidad = appliedFilter.entity;
		}

		if (appliedFilter.typeOfEntity) {
			conditions.tipo_de_entidad = appliedFilter.typeOfEntity;
		}

		if (appliedFilter.gender) {
			conditions.genero = appliedFilter.gender;
		}

		if (appliedFilter.age) {
			conditions.edad = appliedFilter.age;
		}

		if (appliedFilter.passed) {
			conditions.fallecio = appliedFilter.passed;
		}

		if (appliedFilter.date) {
			conditions.fecha_evento = appliedFilter.date;
		}

		if (appliedFilter.createddate) {
			conditions.created_date = appliedFilter.createddate;
		}

		if (appliedFilter.time) {
			conditions.hora_evento = appliedFilter.time;
		}

		if (appliedFilter.municipality) {
			conditions.municipio = appliedFilter.municipality;
		}

		if (appliedFilter.duplicateState) {
			conditions.estado_duplicado = appliedFilter.duplicateState;
		}

		if (events) {
			let subset = _.filter(events, conditions);

			if (appliedFilter.id) {
				subset = _.filter(subset, (o) =>
					o.event_id != null && String(o.event_id).toLowerCase().includes(appliedFilter.id.toLowerCase())
				);
			}

			let ordered;
			if (order.column === 'fecha_evento') {
				ordered = _.orderBy(subset, ['fecha'], [order.type]);
			} else {
				ordered = _.orderBy(subset, [order.column], [order.type]);
			}

			setData(ordered);
		}
		setLoading(false);
	}, [
		events,
		order,
		appliedFilter
	]);

	useEffect(() => {
		if (events) {
			const dataset = _.map(events, (r) => {
				return {
					'ID': r.event_id,
					'1. Sexo': r.sex,
					'2. Género': r.genero,
					'Otro (se auto-identifica como…)': r.genero_otro,
					'3. Si es persona gestante, ¿se encuentra embarazada?': r.embarazada,
					'Especifique # semanas de embarazo': r.semanas_embarazo,
					'4. Edad aproximada': r.edad,
					'5. Fecha del evento (24 de mayo de 2024)': r.fecha_evento,
					'6. Hora (am o pm)': r.hora_evento,
					'7. Municipio': r.municipio,
					'8. Tipo de lugar donde ocurrió el evento': r.lugar,
					'Especifique (otherPlace)': r.otherplace,
					'Barrio/Sector o Vencindario': r.barrio_generic,
					'Descripción del lugar': r.place_description,
					'Código postal': r.zipCode,
					'Longitud': r.longitude_generic,
					'Latitud': r.latitude_generic,
					'9. Se utilizó tirilla de fentanilo': r.isthreshingwasused,
					'De la respuesta ser Sí, ¿cuál fue el resultado de la prueba?': r.istestresult,
					'10. ¿Se utilizó naloxona en este evento?': r.naloxona,
					'Si es No, marcar la razón': r.naloxone_if_no,
					'11. Vía por la cual se administró la Naloxona': r.via_naloxona !== null ? r.via_naloxona.toString() : "",
					'naloxona_dosis (old)': r.naloxona_dosis,
					'Dosis Intranasal': r.dosis_intranasal,
					'Dosis Intramuscular': r.dosis_intramuscular,
					'12. ¿Quién administró la naloxona?': r.administrador_naloxona,
					'13. ¿Los opioides fueron recetados?': r.opiodes_recetados,
					'14. ¿Qué opioide(s) había consumido la persona afectada? (marque todas las que aplique):': r.opiodes !== null ? r.opiodes.toString() : "",
					'Especifique otro opioide/fármaco': r.opiodes_otro,
					'15. Otras sustancias consumidas (marque todas las que aplique):': r.other_substance !== null ? r.other_substance.toString() : "",
					'Especifique (other_substance_especifique)': r.other_substance_especifique,
					'15b. Opioides adquiridos en': r.opioides_lugar,
					'16. Síntomas de sobredosis que presentó la persona afectada (marque todas las que aplique)': r.sintomas_sobredosis !== null ? r.sintomas_sobredosis.toString() : "",
					'Especifique (other_symptoms_overdose)': r.other_symptoms_overdose,
					'17. La persona afectada por la sobredosis se encuentra (marque todas las que aplique)': r.estado_persona !== null ? r.estado_persona.toString() : "",
					'18. La persona afectada fue trasladada a': r.traslado,
					'Especifique (traslado_otro)': r.traslado_otro,
					'19. Breve descripción del evento y/o comentarios adicionales': r.descripcion_evento,
					'20. Reside en Puerto Rico': r.residente,
					'Favor indique el país donde reside': r.pais,
					'Favor indique el estado donde reside': r.estado,
					'21. Vivienda de la persona afectada': r.pernocta,
					'22. Persona afectada se encuentra recibiendo tratamiento con': r.formal_treatment,
					'23. Instituciones donde estuvo la persona afectada por la sobredosis en el último mes (marque todas las que aplique)': r.instituciones !== null ? r.instituciones.toString() : "",
					'Especifique (especifique_instituciones)': r.especifique_instituciones,
					'24. Estrategia de reducción de daños que ha participado la persona afetada en el último mes (marque todas las que aplique)': r.estrategia_de_reduccion !== null ? r.estrategia_de_reduccion.toString() : "",
					'Especifique (especifique_estrategia)': r.especifique_estrategia,
					'25. Formulario respondido por': r.form_responsible,
					'26. ¿Qué entidad le brindó la naloxona para el uso en la comunidad?': r.proveedor_naloxona,
					'Especifique (proveedor_naloxona_otro)': r.proveedor_naloxona_otro,
					'Inicial nombre padre': r.father_initial,
					'Inicial nombre madre': r.mother_initial,
					'Día de su nacimiento': r.father_dob,
					'Inicial del mes de su nacimiento': r.month_of_birth,
					'28. Nombre': r.nombre,
					'29. Apellidos': r.apellido,
					'30. Teléfono': r.telefono,
					'31. Correo electrónico': r.email,
					'32. Tipo de Entidad': r.tipo_de_entidad,
					'33. A que entidad, si alguna, usted pertenece': r.entidad,
					'Otra Entidad': r.entidad_otro,

					'34. Necesita Naloxona': r.need_naloxone,
					fecha_creacion_evento: r.created_date,
					editor: r.editedBy,
					fecha_edicion_evento: r.updated_date !== null ? r.updated_date : "",
					'Estado Duplicado': r.estado_duplicado,
					'Fecha Marcado Duplicado': r.fecha_marcado_duplicado,
					/*
										genero: r.genero,
										genero_otro: r.genero_otro,
										embarazada: r.embarazada,
										semanas_embarazo: r.semanas_embarazo,
										edad_aproximada: r.edad,
										fecha_evento : formatter.format(new Date(r.fecha_evento)),
										hora_evento: r.hora_evento,
										direccion: r.direccion,
										lugar: r.lugar,
										region: r.region,
										municipio: r.municipio,
										codigo_postal: r.zipCode,
										latitud: r.latitud,
										longitud: r.longitud,
										naloxona: r.naloxona,
										naloxona_dosis: r.naloxona_dosis,
										administrador_naloxona: r.administrador_naloxona,
										administrador_naloxona_otro: r.administrador_naloxona_otro,
										administrador_naloxona_adiestrado: r.administrador_adiestrado,
										opiodes_recetados: r.opiodes_recetados,
										opiodes: r.opiodes !== null ? r.opiodes.toString() : "",
										opiodes_otro: r.opiodes_otro,
										persona_estabilizada: r.persona_estabilizada,
										fatalidad: r.fallecio,
										traslado: r.traslado,
										traslado_otro: r.traslado_otro,
										descripcion_evento: r.descripcion_evento,
										residente: r.residente,
										pais: r.pais,
										estado: r.estado,
										pernocta: r.pernocta,
										pernocta_otro: r.pernocta_otro,
										institucion: r.institucion,
										institucion_otro: r.institucion_otro,
										proveedor_naloxona: r.proveedor_naloxona,
										proveedor_naloxona_otro: r.proveedor_naloxona_otro,
										nombre: r.nombre,
										apellido: r.apellido,
										telefono: r.telefono,
										email: r.email,
										tipo_de_entidad: r.tipo_de_entidad,
										entidad: r.entidad,
										creador_evento: r.createdBy,
										estado_duplicado: r.duplicateState,
										fecha_creacion_evento:  formatter.format(new Date(r.created_date)),   
										editor: r.editedBy,
										fecha_edicion_evento: r.updated_date !== null ?  formatter.format(new Date(r.updated_date)) : "",  
										//Nuevos
										sex: r.sex,
										otherPlace: r.otherPlace,
										isThreshingWasUsed: r.isThreshingWasUsed,
										istestresult: r.istestresult,
										naloxone_if_no: r.naloxone_if_no,
										dosisIntranasal: r.dosisIntranasal,
										dosisIntramuscular: r.dosisIntramuscular,
										administrador: r.administrador,
										opioidesLugar: r.opioidesLugar,
										
										sintomas_sobredosis: r.sintomas_sobredosis !== null ? r.sintomas_sobredosis.toString() : "",
										estado_persona: r.estado_persona !== null ? r.estado_persona.toString() : "",
										descripcion_evento: r.descripcion_evento,
										//modified
										naloxone: r.naloxone,
					*/

				};
			});

			setArray(dataset);
		}
	}, [events]);

	const update = (r) => {
		setOpen(true);
		setEvent(r);
	};

	const remove = (r) => {
		setConfirm(true);
		setEvent(r);
	};

	return (
		<>
			<MainMenu />
			<Confirm
				size="mini"
				header={() => <Header as="h4" content="Remover Evento" />}
				content="¿Esta seguro que desea remover este evento de manera permanente?"
				open={confirm}
				onCancel={() => {
					setConfirm(false);
					setEvent(null);
				}}
				cancelButton={() => (
					<Button
						size="mini"
						content="Cancelar"
						onClick={() => {
							setConfirm(false);
							setEvent(null);
						}}
					/>
				)}
				confirmButton={() => (
					<Button
						size="mini"
						color="orange"
						content="Remover"
						loading={removing}
						onClick={() => {
							setRemoving(true);

							EventService.deleteEvent(event.doc).then(res => {
								setConfirm(false);
								setEvent(null);
								setRemoving(false);
								dispatch(fetchData(auth));
							}).catch((error) => {
								console.log(error);
								setRemoving(false);
								EventService.logError({ message: error.message, stack: error.stack });
							});


						}}
					/>
				)}
			/>
			<EventEditor
				open={open}
				event={event}
				onClose={() => {
					setOpen(false);
					setEvent(null);
				}}
			/>
			<Container fluid className="mb-40 mt-40 p-100">
				<Grid stackable >
					<Grid.Row columns={1}>
						<Grid.Column>
							<div
								style={{
									display: 'flex',
									alignItems: 'center',
									marginBottom: '10px',
								}}
							>
								{/* <Image
									src={Logo}
									style={{ marginRight: '10px', width: '40px' }}
								/> */}
								<div>
									<div style={{ fontWeight: 'bold' }}>
										Gobierno de Puerto Rico
									</div>
									<div>
										Administración de Servicios de Salud Mental y Contra la
										Adicción
									</div>
								</div>
							</div>
							<div className="clearfix" />
							<Header as="h1">
								Archivo
								<Header.Subheader>
									Archivo de eventos de posibles sobredosis por consumo de
									opiáceos y administración de naloxona
								</Header.Subheader>
							</Header>
							<p className="small justify">
								Puerto Rico Comprehensive Addiction and Recovery Act El proyecto
								FR-CARA desarrolló este informe con el propósito de documentar{' '}
								<span className="strong">
									{' '}
									los eventos de posibles sobredosis de opioides y el uso de
									naloxona
								</span>{' '}
								en dichos eventos. Se recoge información de la persona afectada,
								detalles del evento de la posible sobredosis y el tipo de
								servicios que fueron ofrecidos.
							</p>
						</Grid.Column>
					</Grid.Row>


					<>
						<Grid.Row columns={1}>
							<Grid.Column>
								<ExportButton data={array} />
							</Grid.Column>
						</Grid.Row>
						<Grid.Row columns={1}>
							<Grid.Column>
								<Accordion
									fluid
									styled
									exclusive={false}
									panels={[
										{
											key: 0,
											title: {
												content: 'Filtrar Datos',
											},
											content: {
												content: (
													<Form size="small">
														<Form.Group widths="equal">
															<Form.Input
																name="id"
																label="ID"
																placeholder="Buscar por ID..."
																value={filter.id}
																onChange={(e) => {
																	setFilter({ ...filter, id: e.target.value });
																}}
															/>
															<Form.Field
																name="entity"
																label="Entidades"
																placeholder="Seleccionar..."
																control={Dropdown}
																fluid
																search
																selection
																clearable
																value={filter.entity}
																onChange={(e, { value }) => {
																	setFilter({ ...filter, entity: value });
																}}
																noResultsMessage="No hubo resultados"
																options={_.map(
																	_.filter(
																		_.uniqBy(events, 'entidad'),
																		(o) => {
																			return o.entidad !== '';
																		}
																	),
																	(item) => {
																		return {
																			key: item.entidad,
																			text: item.entidad,
																			value: item.entidad,
																		};
																	}
																)}
															/>
															<Form.Field
																name="typeOfEntity"
																label="Tipo de Entidad"
																placeholder="Seleccionar..."
																control={Dropdown}
																fluid
																search
																selection
																clearable
																value={filter.typeOfEntity}
																onChange={(e, { value }) => {
																	setFilter({ ...filter, typeOfEntity: value });
																}}
																noResultsMessage="No hubo resultados"
																options={_.map(
																	_.filter(
																		_.uniqBy(events, 'tipo_de_entidad'),
																		(o) => {
																			return o.tipo_de_entidad !== '';
																		}
																	),
																	(item) => {
																		return {
																			key: item.tipo_de_entidad,
																			text: item.tipo_de_entidad,
																			value: item.tipo_de_entidad,
																		};
																	}
																)}
															/>
															<Form.Field
																name="gender"
																label="Género"
																placeholder="Seleccionar..."
																control={Dropdown}
																fluid
																search
																selection
																clearable
																value={filter.gender}
																onChange={(e, { value }) => {
																	setFilter({ ...filter, gender: value });
																}}
																noResultsMessage="No hubo resultados"
																options={_.map(
																	_.filter(
																		_.uniqBy(events, 'genero'),
																		(o) => {
																			return o.genero !== '';
																		}
																	),
																	(item) => {
																		return {
																			key: item.genero,
																			text: item.genero,
																			value: item.genero,
																		};
																	}
																)}
															/>
															<Form.Field
																name="age"
																label="Edad"
																placeholder="Seleccionar..."
																control={Dropdown}
																fluid
																search
																selection
																clearable
																value={filter.age}
																onChange={(e, { value }) => {
																	setFilter({ ...filter, age: value });
																}}
																noResultsMessage="No hubo resultados"
																options={_.map(
																	_.filter(_.uniqBy(events, 'edad'), (o) => {
																		return o.edad !== '';
																	}),
																	(item) => {
																		return {
																			key: item.edad,
																			text: item.edad,
																			value: item.edad,
																		};
																	}
																)}
															/>

															<Form.Field
																name="passed"
																label="Fatalidad"
																placeholder="Seleccionar..."
																control={Dropdown}
																fluid
																search
																selection
																clearable
																value={filter.passed}
																onChange={(e, { value }) => {
																	setFilter({ ...filter, passed: value });
																}}
																noResultsMessage="No hubo resultados"
																options={_.map(
																	_.filter(
																		_.uniqBy(events, 'fallecio'),
																		(o) => {
																			return o.fallecio !== '';
																		}
																	),
																	(item) => {
																		return {
																			key: item.fallecio,
																			text: item.fallecio,
																			value: item.fallecio,
																		};
																	}
																)}
															/>

														</Form.Group>
														<Form.Group widths="equal">

															<Form.Field
																name="date"
																label="Fecha de Evento"
																placeholder="Seleccionar..."
																control={Dropdown}
																fluid
																search
																selection
																clearable
																value={filter.date}
																onChange={(e, { value }) => {
																	setFilter({ ...filter, date: value });
																}}
																noResultsMessage="No hubo resultados"
																options={_.map(
																	_.filter(
																		_.uniqBy(events, 'fecha_evento'),
																		(o) => {
																			return o.fecha_evento !== '';
																		}
																	),
																	(item) => {
																		// console.log({
																		// 	base: item.fecha_evento,
																		// 	newDate: new Date(item.fecha_evento),
																		// 	formattedDate: formatter.format(new Date(item.fecha_evento))
																		// })
																		return {
																			key: item.fecha_evento,
																			text: formatDate(item.fecha_evento),
																			value: item.fecha_evento,
																		};
																	}
																)}
															/>
															<Form.Field
																name="time"
																label="Hora"
																placeholder="Seleccionar..."
																control={Dropdown}
																fluid
																search
																selection
																clearable
																value={filter.time}
																onChange={(e, { value }) => {
																	setFilter({ ...filter, time: value });
																}}
																noResultsMessage="No hubo resultados"
																options={_.map(
																	_.orderBy(
																		_.filter(
																			_.uniqBy(events, 'hora_evento'),
																			(o) => {
																				return o.hora_evento !== '';
																			}
																		),
																		['hora_evento'],
																		['asc']
																	),
																	(item) => {
																		return {
																			key: item.hora_evento,
																			text: item.hora_evento,
																			value: item.hora_evento,
																		};
																	}
																)}
															/>
															<Form.Field
																name="municipality"
																label="Municipio"
																placeholder="Seleccionar..."
																control={Dropdown}
																fluid
																search
																selection
																clearable
																value={filter.municipality}
																onChange={(e, { value }) => {
																	setFilter({
																		...filter,
																		municipality: value,
																	});
																}}
																noResultsMessage="No hubo resultados"
																options={_.map(
																	_.filter(
																		_.uniqBy(events, 'municipio'),
																		(o) => {
																			return o.municipio !== '';
																		}
																	),
																	(item) => {
																		return {
																			key: item.municipio,
																			text: item.municipio,
																			value: item.municipio,
																		};
																	}
																)}
															/>

															<Form.Field
																name="createddate"
																label="Fecha de Registro"
																placeholder="Seleccionar..."
																control={Dropdown}
																fluid
																search
																selection
																clearable
																value={filter.createddate}
																onChange={(e, { value }) => {
																	setFilter({ ...filter, createddate: value });
																}}
																noResultsMessage="No hubo resultados"
																options={_.map(
																	_.filter(
																		_.uniqBy(events, 'created_date'),
																		(o) => {
																			return o.created_date !== '';
																		}
																	),
																	(item) => {
																		return {
																			key: item.created_date,
																			text: formatDate(item.created_date),
																			value: item.created_date,
																		};
																	}
																)}
															/>
															<Form.Field
																name="duplicateState"
																label="Estado Duplicado"
																placeholder="Seleccionar..."
																control={Dropdown}
																fluid
																search
																selection
																clearable
																value={filter.duplicateState}
																onChange={(e, { value }) => {
																	setFilter({ ...filter, duplicateState: value });
																}}
																noResultsMessage="No hubo resultados"
																options={_.map(
																	_.filter(
																		_.uniqBy(events, 'estado_duplicado'),
																		(o) => {
																			return o.estado_duplicado !== '';
																		}
																	),
																	(item) => {
																		return {
																			key: item.estado_duplicado,
																			text: item.estado_duplicado,
																			value: item.estado_duplicado,
																		};
																	}
																)}
															/>
														</Form.Group>
														<Button
															type="button"
															color='orange'
															size="mini"
															content="Filtrar"
															onClick={() => setAppliedFilter(filter)}
														/>
														<Button
															type="button"
															size="mini"
															content="Limpiar"
															onClick={() => {
																setFilter(emptyFilter);
																setAppliedFilter(emptyFilter);
															}}
														/>
													</Form>
												),
											},
										},
										{
											key: 1,
											title: {
												content: 'Ordenar Datos',
											},
											content: {
												content: (
													<Form size="small">
														<Form.Group widths="equal">
															<Form.Field
																label="Tipo"
																control={Dropdown}
																fluid
																selection
																value={order.type}
																onChange={(e, { value }) => {
																	setOrder({ ...order, type: value });
																}}
																options={[
																	{
																		key: 'asc',
																		text: 'Ascendente',
																		value: 'asc',
																	},
																	{
																		key: 'desc',
																		text: 'Descendente',
																		value: 'desc',
																	},
																]}
															/>
															<Form.Field
																label="Columna"
																control={Dropdown}
																fluid
																selection
																value={order.column}
																onChange={(e, { value }) => {
																	setOrder({ ...order, column: value });
																}}
																options={[
																	{
																		key: 'Entidad',
																		text: 'Entidad',
																		value: 'entidad',
																	},
																	{
																		key: 'Género',
																		text: 'Género',
																		value: 'genero',
																	},
																	{
																		key: 'Edad',
																		text: 'Edad',
																		value: 'edad',
																	},
																	{
																		key: 'fallecio',
																		text: 'Fatalidad',
																		value: 'fallecio',
																	},
																	{
																		key: 'Fecha',
																		text: 'Fecha de Evento',
																		value: 'fecha_evento',
																	},
																	{
																		key: 'Hora',
																		text: 'Hora',
																		value: 'hora_evento',
																	},
																	{
																		key: 'Municipio',
																		text: 'Municipio',
																		value: 'municipio',
																	},
																	{
																		key: 'Fecha de Registro',
																		text: 'Fecha de Registro',
																		value: 'created_date',
																	},
																]}
															/>
														</Form.Group>
													</Form>
												),
											},
										},
									]}
								/>
							</Grid.Column>
						</Grid.Row>
					</>


					{!loading && data && data.length === 0 && (
						<div
							className="txt-center txt-uppercase mt-40"
							style={{ width: '100%' }}
						>
							No existen datos en su perfil
						</div>
					)}
					{(loading || !data) && (
						<div
							className="txt-center txt-uppercase mt-40"
							style={{ width: '100%' }}
						>
							Cargando Datos...
						</div>
					)}
					{!loading && data && data.length > 0 && (
						<>

							<Grid.Row columns={1}>
								<Grid.Column>
									<Table
										striped
										size="small"
										className="small"
										definition
										singleLine
									>
										<Table.Header>
											<Table.Row>
												<Table.HeaderCell className="small" textAlign="center">
													#
												</Table.HeaderCell>
												<Table.HeaderCell className="small">ID</Table.HeaderCell>
												<Table.HeaderCell className="small">Entidad</Table.HeaderCell>
												<Table.HeaderCell className="small" textAlign="center">Tipo de Entidad</Table.HeaderCell>
												<Table.HeaderCell className="small" textAlign="center">Género</Table.HeaderCell>
												<Table.HeaderCell className="small" textAlign="center">Edad</Table.HeaderCell>
												<Table.HeaderCell className="small" textAlign="center">Fatalidad</Table.HeaderCell>
												<Table.HeaderCell className="small" textAlign="center">Fecha Evento</Table.HeaderCell>
												<Table.HeaderCell className="small" textAlign="center">Hora</Table.HeaderCell>
												<Table.HeaderCell className="small" textAlign="center">Fecha Registro</Table.HeaderCell>
												<Table.HeaderCell className="small" textAlign="center">Municipio</Table.HeaderCell>
												<Table.HeaderCell className="small" textAlign="center">Estado Duplicado</Table.HeaderCell>
												<Table.HeaderCell />
											</Table.Row>
										</Table.Header>
										<Table.Body>
											{_.map(data, (e, index) => {
												return (
													<Table.Row key={e.doc} className="small">
														<Table.Cell textAlign="center">
															{index + 1}
															{/* {e.event_id} */}
														</Table.Cell>
														<Table.Cell>{e.event_id}</Table.Cell>
														<Table.Cell>{e.entidad}</Table.Cell>
														<Table.Cell textAlign="center">{e.tipo_de_entidad}</Table.Cell>
														<Table.Cell textAlign="center">{e.genero}</Table.Cell>
														<Table.Cell textAlign="center">{e.edad}</Table.Cell>
														<Table.Cell textAlign="center">{e.estado_persona?.includes('Murió') ? 'Sí' : 'No'}</Table.Cell>
														<Table.Cell textAlign="center">{e.fecha}</Table.Cell>
														<Table.Cell textAlign="center">{e.hora_evento}</Table.Cell>
														<Table.Cell textAlign="center">{formatDate(e.created_date)}</Table.Cell>
														<Table.Cell textAlign="center">{e.municipio}</Table.Cell>
														<Table.Cell textAlign="center">{e.estado_duplicado}</Table.Cell>
														<Table.Cell textAlign="center">

															{(auth.details.role === 'Administrador') && (
																<Button
																	size="mini"
																	icon="close"
																	onClick={() => remove(e)}
																/>
															)}
															<Button
																size="mini"
																icon="pencil"
																onClick={() => update(e)}
															/>
														</Table.Cell>
													</Table.Row>
												);
											})}
										</Table.Body>
									</Table>
								</Grid.Column>
							</Grid.Row>
						</>
					)}
				</Grid>
			</Container>
		</>
	);
}

export default Archive;
